export const isWalmartDiscountCode = (discount_code: string): boolean => {
  return discount_code.startsWith("WM24");
};
